import { createContext, useContext, ReactNode, useState } from 'react';
import { SubjectTeacher } from 'src/models';

interface SubjectContextProps {
  subject: SubjectTeacher;
  setSubject: (subject: SubjectTeacher) => void;
}

export const SubjectContext = createContext<SubjectContextProps | undefined>(
  undefined
);

export const useSubject = () => {
  const context = useContext(SubjectContext);
  if (!context) {
    throw new Error('useSubject must be used within a SubjectProvider');
  }
  return context;
};

export const SubjectProvider = ({ children }: { children: ReactNode }) => {
  const [subject, setSubject] = useState<SubjectTeacher>({
    SubjectCode: '',
    SubjectName: '',
    Group: '',
    Plan: '',
    Academy: '',
  });

  return (
    <SubjectContext.Provider value={{ subject, setSubject }}>
      {children}
    </SubjectContext.Provider>
  );
};
